/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.addEventListener('change', function (event) {
  addQtyChangeListen()
});

addQtyChangeListen()

function addQtyChangeListen() {
  const currentUrl = location.href
  if (currentUrl.includes('/cart')) {
    const buttons = Array.from(document.querySelectorAll('.quantity-selector__button'))
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const targetId = button.getAttribute('target-id')
        if (targetId) {
          smoothScroll(targetId)
        }
      });
    });
  }
}










function reloadCart() {
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
}

async function changeCartLineItem(lineItemVariantId, selectedVariantId, quantity, oldSize, selectElement, backorder = null) {
  console.log(lineItemVariantId, selectedVariantId, quantity, oldSize, selectElement, backorder)
  if (!backorder && selectElement) {
    const selectedOption = selectElement.selectedOptions[0];
    backorder = selectedOption.getAttribute('backorder');
  }

  console.log('Backorder:', backorder);
  await addItem(selectedVariantId, quantity)//add the new variant
  if (backorder) {
    await updateItemById(selectedVariantId, quantity, { "Backorder": backorder })//add the new variant
  }
  await updateItemById(lineItemVariantId, 0)//remove the old variant
  reloadCart()
  console.log(await getCartObj())
}

async function changeCartLineItemButton(lineItemVariantId, selectedVariantId, quantity, oldSize, selectElement, run) {
  if (run) {

    const text = selectElement.querySelector('.block-swatch__item-text')
    if (text) {
      text.innerHTML = window.icons["search-loader"]
    }

    console.log(selectElement)
    const parent = selectElement.parentNode
    if (parent) {
      const children = Array.from(parent.children)
      for (const child of children) {
        const element = child.querySelector('.block-swatch__item')
        if (element) {
          element.classList.remove('selected')
        }
      }
    }
    const selectElementClass = selectElement.querySelector('.block-swatch__item')
    if (selectElementClass) {
      selectElementClass.classList.add('selected')
    }
    const backorder = selectElement.getAttribute('backorder');
    await changeCartLineItem(lineItemVariantId, selectedVariantId, quantity, oldSize, null, backorder)
  }
}

async function getCartObj() {
  const result = await fetch("/cart.json");

  if (result.status === 200) {
    return result.json();
  }

  throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

async function updateItem(data) {
  const result = await fetch("/cart/change.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify(data)
  });

  console.log(result)

}

async function addItem(variantId, quantity, properties = {}) {
  const result = await fetch("/cart/add.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
      properties: properties
    })
  })
  console.log(result.status)

}

async function updateItemById(lineItemId, newQuantity, newProperties = {}) {
  await updateItem({
    id: lineItemId,
    quantity: newQuantity,
    properties: newProperties
  });
}










function smoothScroll(elementId) {
  if (!elementId.includes('no-target')) {
    const maxRetry = 5
    let currentAttempt = 1

    const checkElement = document.getElementById(elementId);
    if (checkElement) {
      checkElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      const intervalId = setInterval(() => {
        const element = document.getElementById(elementId);

        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          clearInterval(intervalId);
        }
        if (currentAttempt === maxRetry) {
          clearInterval(intervalId);
        }
        currentAttempt++

      }, 500);
    }
  }
}

async function removeUnavailableItems() {
  try {
    const data = {}

    const lineItemsTableCont = document.getElementById('cart-items--unavailable')
    const table = lineItemsTableCont.querySelector('table')
    const tbody = table.querySelector('tbody')
    const rows = Array.from(tbody.querySelectorAll('tr'))

    for (const row of rows) {
      const lineItemId = row.getAttribute('line-item-id')
      const lineItemTotalQty = parseInt(row.getAttribute('line-item-qty'))
      const lineItemQty = parseInt(row.querySelector('input').value)

      data[lineItemId] = lineItemTotalQty - lineItemQty
    }

    await updateCart(JSON.stringify(data))
  } catch (error) {
    location.reload()
  }

}

async function updateCart(data) {
  data = JSON.parse(data)

  console.log(data)

  const cart = await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({ updates: data })
  });

  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));

  return cart.json();
}

async function getCart() {
  const result = await fetch("/cart.json");

  if (result.status === 200) {
    return result.json();
  }

  throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

//this is when the product is changed and it adds variant metadfields to the product specs table (keys to get values)
const metafieldKeys = ["product_weight", "deals", "custom_order", "color", "release_date", "current_promo", "package_count", "product_information", "season", "scent", "grit", "coverage", "viscosity", "finish", "on_sale", "size", "length", "width", "height"]


//set global variables
let nearestLocation;

//set the current store
function setStore(location, element, attribute) {
  jQuery.post(window.Shopify.routes.root + 'cart/update.js', `attributes[${attribute}]=${location}`);
  localStorage.setItem('my_store', location)
  if (element !== null) {
    document.getElementById(element).innerHTML = icons['search-loader']
    setTimeout(function () {
      const storeSelectorMobile = document.getElementById('storeSelectorMobile')
      if (storeSelectorMobile) {
        storeSelectorMobile.click()
      }
      const reload = document.getElementById('reloadProductGrid')
      if (reload) {
        reload.click()
      } else {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
      const storeOptions = document.getElementsByName('store-option')
      for (let i = 0; i < storeOptions.length; i++) {
        const currentStoreId = storeOptions[i].id
        const textElement = document.getElementById(`store_selector--${currentStoreId}`)
        textElement.innerHTML = `<div class="link" onclick="setStore('${currentStoreId}',this.id,'my_store')" style="cursor:pointer" id="storeChanger--${currentStoreId}"><b>${locale.header.general.set_store}</b></div>`
      }
      setTimeout(() => {
        document.getElementById(element).innerHTML = `${icons['store-availability-in-stock']} ${locale.header.general.my_store}`
      }, 50);
    }, 500);
  }
}

var my_store = localStorage.getItem('my_store') || 'warehouse'
var matchingStore = storeDetails.find(store => store.ids === my_store)

//header mobile store icon click
var mobileStore = document.getElementById("storeSelectorMobile");
var mobileStoreCurrent = 'default'
function changeIcon() {
  if (mobileStoreCurrent === 'default') {
    mobileStore.innerHTML = icons['close']
    mobileStoreCurrent = 'x'
  } else {
    mobileStore.innerHTML = icons['address']
    mobileStoreCurrent = 'default'
  }
}
mobileStore.addEventListener("click", changeIcon);





//product-item.liquid Variant Change
function productItemChange(productID, variantID, productDetails, iso) {

  my_store = localStorage.getItem('my_store') || 'warehouse'
  matchingStore = storeDetails.find(store => store.ids === my_store)

  productDetails = productDetails.replaceAll('|||', "'")
  productDetails = JSON.parse(productDetails)

  let matchingInventory = 0


  //get the selectedVariant
  const variants = productDetails.variants
  const matchingVariant = variants.find(item => item.details.id === parseInt(variantID));
  console.log(matchingVariant.metafields.custom)
  //set the price variables
  const variantPrice = (matchingVariant.details.price / 100).toFixed(2)
  const variantComparedPrice = (matchingVariant.details.compare_at_price / 100).toFixed(2)
  const currentDate = convertToUTCDate(new Date().toISOString()).getTime();

  //determin if the product is new
  const newCutoff = currentDate - 2592000 * 1000; // 2592000 seconds in 30 days
  const publishedDate = convertToUTCDate(productDetails.details.published_at).getTime();
  const createdDate = convertToUTCDate(productDetails.details.created_at).getTime();

  // Define the cutoff date for "old" published products (90 days ago)
  const filterOldPublished = currentDate - 7776000 * 1000; // 7776000 seconds in 90 days

  let isNew = false;

  if (publishedDate > newCutoff && createdDate > filterOldPublished) {
    isNew = true;
  }


  //backorder timeframe
  var backorderDefault = null
  try {
    const backorderContainer = document.getElementById(`backorderContainer--${productID}`)
    const backorderMetafield = matchingVariant.metafields.custom.backorder

    console.log(backorderContainer, backorderMetafield)

    if (matchingVariant.metafields.custom.inventory_quantities) {
      matchingInventory = matchingVariant.metafields.custom.inventory_quantities.available[my_store] || 0
    } else {
      matchingInventory = 0
    }
    matchingInventory < 0 ? matchingInventory = 0 : matchingInventory = matchingInventory

    if (settings.show_pickup_from_other_stores) {
      var isShipFromOtherStore = false
      if (matchingInventory === 0 && my_store !== 'warehouse' && matchingVariant.details.inventory_quantity > 0) {
        isShipFromOtherStore = true
        matchingInventory = matchingVariant.details.inventory_quantity
      }
    }

    if (!backorderMetafield && backorderContainer) {
      backorderContainer.innerHTML = ''
    } else if (backorderMetafield && backorderContainer && matchingInventory === 0) {
      backorderContainer.innerHTML = `
        <span class="product-item__inventory inventory inventory--high" style="font-size: smaller;">${locale.product.form.backorders}: ${backorderMetafield}</span>
        <input hidden="" id="backorder" type="text" value="${backorderMetafield}" name="properties[Backorder]">
      `
    } else if (backorderMetafield && backorderContainer && matchingInventory > 0) {
      backorderContainer.innerHTML = ''
    }
    if (backorderMetafield && matchingInventory === 0) {
      backorderDefault = backorderMetafield
    }
  } catch (error) {
    console.error(error)
  }

  //store incoming snippet
  var matchingIncomingExpedted = null
  var incomingText = null
  try {

    //first get inventory qty
    if (matchingVariant.metafields.custom.inventory_quantities) {
      matchingInventory = matchingVariant.metafields.custom.inventory_quantities.available[my_store] || 0
    } else {
      matchingInventory = 0
    }
    matchingInventory < 0 ? matchingInventory = 0 : matchingInventory = matchingInventory


    const incomingContainer = document.getElementById(`nextIncomingDate--${productID}`)

    if (matchingVariant.metafields.custom.incoming_inventory_quantities) {
      if (matchingVariant.metafields.custom.incoming_inventory_quantities[my_store]) {
        var matchingIncoming = matchingVariant.metafields.custom.incoming_inventory_quantities[my_store].quantity
        matchingIncomingExpedted = matchingVariant.metafields.custom.incoming_inventory_quantities[my_store].expected_on
      }
    }

    if (matchingIncomingExpedted && matchingIncoming && settings.low_inventory_threshold >= matchingInventory) {

      const now = new Date()
      const nowYear = now.getFullYear()
      const nowMonth = String(now.getMonth() + 1).padStart(2, '0')
      const nowDay = String(now.getDate()).padStart(2, '0')
      const todayString = `${nowYear}-${nowMonth}-${nowDay}`

      const today = new Date(todayString)
      const expected = new Date(matchingIncomingExpedted)
      const days = calculateDaysDifference(today, expected)

      if (days === 0) {
        incomingText = locale.collection.product.incoming_today
      } else if (days === 1) {
        incomingText = locale.collection.product.incoming_tomorrow
      } else if (days > 1) {
        const expectedOn = new Date(matchingIncomingExpedted + 'T16:00:00Z')
        const formattedDate = expectedOn.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        if (formattedDate || backorderDefault) {
          incomingText = locale.collection.product.incoming_date.replace('{{date}}', formattedDate ? formattedDate : backorderDefault)
        }
      } else if (days < 0 && days > -45) {
        incomingText = locale.collection.product.incoming_on_the_way
      }
      if (incomingContainer) {
        incomingContainer.innerHTML = `<span class="product-item__inventory inventory" style="font-style:italic;font-size:95%">${incomingText}</span>`
      }

    } else {
      if (incomingContainer) {
        incomingContainer.innerHTML = ''
      }
    }


  } catch (error) {
    console.error('incoming inventory is not shown, skipping...', error)
  }



  //store availabilty snippet
  try {
    const availabiltyCont = document.getElementById(`inventoryAvailability--${productID}`)

    const span = document.createElement('span')
    span.classList.add('product-item__inventory')
    span.classList.add('inventory')

    if (matchingVariant.metafields.custom.inventory_quantities) {
      matchingInventory = matchingVariant.metafields.custom.inventory_quantities.available[my_store] || 0
    } else {
      matchingInventory = 0
    }
    matchingInventory < 0 ? matchingInventory = 0 : matchingInventory = matchingInventory

    if (settings.show_pickup_from_other_stores) {
      var isShipFromOtherStore = false
      if (matchingInventory === 0 && my_store !== 'warehouse' && matchingVariant.details.inventory_quantity > 0) {
        isShipFromOtherStore = true
        matchingInventory = matchingVariant.details.inventory_quantity
      }
    }

    if (matchingVariant.details.inventory_policy === 'continue' && matchingInventory === 0 || preOrder) {
      span.classList.add('inventory--high')
      span.classList.add('inventory--noSub')
      if (preOrder) {
        span.innerHTML = `${(locale.collection.product.location_name).replace('{{location}}', matchingStore.name)} - ${locale.collection.product.pre_order}<br><span style="font-style:italic;font-size:95%">${locale.collection.product.releases.replace('{{date}}', releaseDateText)}</span>`
      } else if (customOrder) {
        span.innerHTML = `${(locale.collection.product.location_name).replace('{{location}}', matchingStore.name)} - ${locale.collection.product.custom_order}<br><span style="font-style:italic;font-size:95%">${customOrderText}</span>`
      } else {
        span.innerHTML = `${(locale.collection.product.location_name).replace('{{location}}', matchingStore.name)} - ${matchingIncomingExpedted ? incomingText : locale.collection.product.oversell_stock}<br>`
      }
    } else {
      if (matchingInventory === 0) {
        span.classList.add('inventory--noSub')
        span.innerHTML = `${(locale.collection.product.location_name).replace('{{location}}', matchingStore.name)} - ${locale.collection.product.sold_out}`
      } else {
        span.classList.add('inventory--noSub')
        if (isShipFromOtherStore) {
          span.classList.add('inventory--high')
          span.innerHTML = `${(locale.product.form.in_stock_from_other_store).replace('{{ store_name }}', matchingStore.name)}`
        } else {
          if (settings.low_inventory_threshold >= matchingInventory) {
            span.classList.add('inventory--low')
          } else {
            span.classList.add('inventory--high')
          }
          span.innerHTML = `${(locale.collection.product.location_name).replace('{{location}}', matchingStore.name)} - ${(locale.collection.product.in_stock_with_quantity_count_2).replace('{{count}}', matchingInventory > settings.max_display_inventory ? `${settings.max_display_inventory}+` : matchingInventory)}`
        }
      }
    }
    const storeChanger = document.createElement('a')
    storeChanger.setAttribute('data-action', 'toggle-popover')
    storeChanger.setAttribute('aria-controls', 'store-selector')
    storeChanger.setAttribute('aria-expanded', 'false')
    storeChanger.setAttribute('onclick', "window.scrollTo({ top: 0, behavior: 'smooth' })")
    storeChanger.classList.add('link')
    storeChanger.style.cursor = 'pointer'
    storeChanger.style.fontStyle = 'italic'
    storeChanger.style.fontSize = '85%'
    storeChanger.style.color = 'grey'
    storeChanger.innerHTML = locale.product.labels.change_store

    availabiltyCont.innerHTML = ''
    availabiltyCont.appendChild(span)
    //availabiltyCont.appendChild(storeChanger)
  } catch (error) {
    console.error('inventory is not shown, skipping...')
  }




  //variant id to form input value
  const variantInput = document.getElementById(`productVariantInput--${productID}`)
  variantInput.value = variantID



  //add to cart button
  const buyButton = document.getElementById(`addToCart--${productID}`)
  if (buyButton) {
    if (matchingVariant.details.inventory_policy === 'continue' && matchingInventory === 0) {
      buyButton.classList.remove('button--disabled')
      buyButton.classList.add('button--primary')
      buyButton.disabled = false
      if (preOrder) {
        buyButton.innerText = locale.collection.product.pre_order
      } else if (customOrder) {
        buyButton.innerText = locale.collection.product.custom_order
      } else {
        const backorderMetafield = matchingVariant.metafields.custom.backorder
        if (backorderMetafield) {
          buyButton.innerText = locale.collection.product.backorder_now
        } else {
          buyButton.innerText = locale.collection.product.add_to_cart
        }
      }
    } else {
      if (matchingInventory > 0) {
        buyButton.classList.remove('button--disabled')
        buyButton.classList.add('button--primary')
        buyButton.innerText = locale.collection.product.add_to_cart
        buyButton.disabled = false
      } else {
        buyButton.classList.add('button--disabled')
        buyButton.classList.remove('button--primary')
        isNew === true ? buyButton.innerText = locale.collection.product.coming_soon : buyButton.innerText = locale.collection.product.sold_out
        buyButton.disabled = true
      }
    }
  }


  //update price per
  try {
    const variantSize = matchingVariant.metafields.custom.size[0]
    const variantCount = matchingVariant.metafields.custom.package_count || 1
    const sizeCompareItems = ['ml', 'oz', 'g', 'L', 'kg']
    sizeCompareItems.forEach(item => {
      if (variantSize.includes(item)) {
        if (item === 'kg' || item === 'L') {
          var sizeCompare = item === 'kg' ? 'g' : 'ml'
          var sizeCompareValue = (parseInt(variantSize.replace(item, ''))) * 1000
        } else {
          var sizeCompare = item
          var sizeCompareValue = parseInt(variantSize.replace(item, ''))
        }
        if (sizeCompareValue > 0) {
          var rawValue = (matchingVariant.details.price / 100) / sizeCompareValue / variantCount;
          var roundedValue = Math.round(rawValue * 100) / 100;
          document.getElementById(`pricePerSize--${productID}`).innerHTML = '$' + roundedValue.toFixed(2) + '/' + sizeCompare;
        }
      }
    });
  } catch (error) {
    document.getElementById(`pricePerSize--${productID}`).innerHTML = ''
  }

  //product media
  try {
    const firstImage = matchingVariant.details.featured_image.src
    const secondImage = productDetails.details.media[0].src

    const firstImagealt = matchingVariant.details.featured_image.alt
    const secondImagealt = productDetails.details.media[0].alt

    const imageContainer = document.getElementById(`imageContainer--${productID}`)

    imageContainer.innerHTML = `
      <div class="aspect-ratio " style="padding-bottom: 100.0%">
      <img src="${firstImage}?width=400&height=400" alt="${firstImagealt}"  loading="lazy" class="product-item__primary-image">
      <img src="${secondImage}?width=400&height=400" alt="${secondImagealt}" loading="lazy" class="product-item__secondary-image">
      </div>
    `
  } catch (error) {
    // do nothing if error, keep images the same
  }

  let current_savings;
  let current_savings_type;
  //variant Price
  try {

    if (iso) {
      var iso = iso.split(' - ')
      var currencyCode = iso[0]
      if (iso[1]) {
        var currencySymbol = iso[1]
      }
    }

    const priceList = document.getElementById(`price_list--${productID}`)

    const discountMetafields = matchingInventory > 0 ? matchingVariant.metafields.custom.current_discounts : null

    var discountActive = false
    var discountNewPrice = false
    var discountTitle = null
    var discountEnd = null
    var discountAmount = null
    var discountCurrency = null
    if (discountMetafields && discountMetafields.length > 0) {
      try {
        let discountMetafield = discountMetafields[0]

        try {// try and see if any other discounts have a greater value
          for(const discount of discountMetafields){
          const lastDiscountPercentage = discountMetafield.discountType === 'DiscountPercentage' ? discountMetafield.discountAmount : (((variantPrice - discountMetafield.discountAmount) / variantPrice) - 1) * -1

            if(discount.discountType == 'DiscountAmount'){
              const priceForDiscount = variantPrice - discount.discountAmount
              const discountPercentage = ((priceForDiscount / variantPrice) - 1) * -1
              if(discountPercentage > lastDiscountPercentage){
                discountMetafield = discount
              }
            }
          }
        } catch (error) {
          console.error(error)
        }

        const now = new Date()
        const discountStart = new Date(discountMetafield.discountStart)
        discountEnd = discountMetafield.discountEnd ? new Date(discountMetafield.discountEnd) : null
        discountTitle = discountMetafield.discountTitle
        discountAmount = discountMetafield.discountAmount
        discountCurrency = discountMetafield.discountCurrency
        const discountType = discountMetafield.discountType

        if (now >= discountStart && (now <= discountEnd || !discountEnd)) {
          discountActive = true
          if (discountType === 'DiscountAmount' || discountType === 'DiscountPercentage') {
              current_savings_type = discountType
            if (discountType === 'DiscountPercentage') {
              try {
              current_savings = (parseFloat(discountAmount) * 100).toFixed(0)                
              } catch (error) {
                console.error(error)
              }
              const multiplier = 1 - discountAmount
              discountNewPrice = `${iso !== '' ? `${currencySymbol}${(variantPrice * multiplier).toFixed(2)} ${settings.currency_code_enabled ? currencyCode : ''}` : `$${variantPrice}`}`
            } else if (discountType === 'DiscountAmount') {
              if (currencyCode === discountCurrency) {
              try {
              current_savings = parseFloat(discountAmount).toFixed(2)            
              } catch (error) {
                console.error(error)
              }
                discountNewPrice = `${iso !== '' ? `${currencySymbol}${(variantPrice - discountAmount).toFixed(2)} ${settings.currency_code_enabled ? currencyCode : ''}` : `$${variantPrice}`}`
              } else {
                discountNewPrice = 0
              }
            }
          }
        }
        console.log(now, discountStart, discountEnd, now >= discountStart && now <= discountEnd, discountType)

      } catch (error) {
        console.error(error)
      }
    }
    console.log(discountNewPrice)


    if (customer.b2b) {
      priceList.innerHTML = `
          <div class="product-item__price-list price-list b2b-price">
            <div class="b2b-price-heading">${locale.product.general.your_price}:</div>
            <div class="price">${iso !== '' ? `${currencySymbol}${variantPrice} ${settings.currency_code_enabled ? currencyCode : ''}` : `$${variantPrice}`}</div>
          </div>
          ${parseFloat(variantPrice) < parseFloat(variantComparedPrice) ? `
            <div class="product-item__price-list price-list b2b-price">
              <div class="b2b-price-heading salon-price-heading">${locale.product.general.selling_price}:</div>
              <div class="price salon-pricing">${iso !== '' ? `${currencySymbol}${variantComparedPrice} ${settings.currency_code_enabled ? currencyCode : ''}` : `$${variantComparedPrice}`}</div>
            </div>
          ` : ``}

      `
    } else {
      priceList.innerHTML = `
        <div class="product-item__price-list price-list">
          ${parseFloat(variantPrice) < parseFloat(variantComparedPrice) ?
          `
              <span class="price price--highlight">
                <span class="visually-hidden">${locale.product.general.sale_price}</span>
                ${iso !== '' ? `${currencySymbol}${variantPrice} ${settings.currency_code_enabled ? currencyCode : ''}` : `$${variantPrice}`}
              </span>
              <span class="price price--compare">
                <span class="visually-hidden">${locale.product.general.regular_price}</span>
                ${iso !== '' ? `${currencySymbol}${variantComparedPrice} ${settings.currency_code_enabled ? currencyCode : ''}` : `$${variantComparedPrice}`}
              </span>
            `:
          `
          ${discountActive && discountNewPrice !== 0 ? `
            <span class="sale-price">${locale.product.general.sale_price} <span class="price--highlight">${discountNewPrice}</span></span>
          ` : ''}
              <span class="price ${discountActive && discountNewPrice !== 0 ? 'crossed' : ''}">
                <span class="visually-hidden">${locale.product.general.sale_price}</span>
                ${iso !== '' ? `${currencySymbol}${variantPrice} ${settings.currency_code_enabled ? currencyCode : ''}` : `$${variantPrice}`}
              </span>
            `
        }
        </div>
      `
    }

    const discountBadge = document.getElementById(`sale-badge--${productID}`)
    if (discountActive && discountNewPrice !== 0) {
      const discountEndYear = discountEnd ? discountEnd.getFullYear() : null;
      const discountEndMonth = discountEnd ? String(discountEnd.getMonth() + 1).padStart(2, '0') : null;
      const discountEndDay = discountEnd ? String(discountEnd.getDate()).padStart(2, '0') : null;
      discountBadge.innerHTML = `
        <div class="sale-title">${discountTitle}</div> 
        ${discountEnd ? `<div class="sale-ends">Ends: <span class="sale-ends-date">${discountEndYear}-${discountEndMonth}-${discountEndDay}</span></div>` : ''}
      `
    } else {
      discountBadge.innerHTML = ''
    }

  } catch (error) {
    console.error(error.message)
  }

  //variant promo details
  try {
    const promoInfo = document.getElementById(`promo-text--${productID}`)
    if (promoInfo) {
      const metafield = matchingVariant.metafields.properties.special_manufacturing_info
      if (metafield) {
        promoInfo.innerHTML = metafield
      } else {
        promoInfo.innerHTML = ''
      }
    }
  } catch (error) {
    console.error(error)
  }


  //product badges
  try {
    //determin if the product is preorder
    var preOrder = false
    if (matchingVariant.metafields.custom.release_date) {
      const releaseDate = convertToUTCDate(matchingVariant.metafields.custom.release_date).getTime();
      if (currentDate < releaseDate) {
        preOrder = true;
      }
      var releaseDateText = matchingVariant.metafields.custom.release_date.split('T')[0]
    }

    //determin if the product is custom order
    var customOrder = false
    if (matchingVariant.metafields.custom.custom_order) {
      var customOrderText = matchingVariant.metafields.custom.custom_order
      customOrder = true
    }

    //determin if the product is discontinued
    var discontinued = false
    if (matchingVariant.metafields.custom.deals) {
      const deals = matchingVariant.metafields.custom.deals
      if (deals.includes("Discontinued")) {
        discontinued = true
      }
    }

    //determin if the product is limited
    var limited = false
    if (matchingVariant.metafields.custom.deals) {
      const deals = matchingVariant.metafields.custom.deals
      if (deals.includes("Limited Edition")) {
        limited = true
      }
    }

    //determin if the product is clearance
    var clearance = false
    if (matchingVariant.metafields.custom.deals) {
      const deals = matchingVariant.metafields.custom.deals
      if (deals.includes("Clearance")) {
        clearance = true
      }
    }


    const badgeContainer = document.getElementById(`badge-container--${productID}`)

    //determin if the product is on sale
    if (parseFloat(variantComparedPrice) > parseFloat(variantPrice)) {
      if ((variantComparedPrice / variantPrice) - 1 < 0.1) {
        var savingsText = `${iso.split(' - ')[1]}${(variantComparedPrice - variantPrice).toFixed(2)}`
      } else {
        var savingsText = `${(((variantPrice / variantComparedPrice) - 1) * -100).toFixed(0)}%`
      }
      //check if the savings badge exist
      const savingsBadge = document.getElementById(`savings-badge--${productID}`)
      if (savingsBadge) {
        savingsBadge.innerHTML = locale.collection.product.discount_html.replace('{{savings}}', savingsText)
      } else {
        const savingsBadgeSpan = document.createElement('span')
        savingsBadgeSpan.classList.add('product-label')
        savingsBadgeSpan.classList.add('product-label--on-sale')
        savingsBadgeSpan.id = `savings-badge--${productID}`
        savingsBadgeSpan.innerHTML = locale.collection.product.discount_html.replace('{{savings}}', savingsText)

        badgeContainer.appendChild(savingsBadgeSpan)
      }
    } else if (current_savings && current_savings_type) {
      if(current_savings_type === 'discountPercentage'){
        var savingsText = `${current_savings}%`
      } else {
        var savingsText = `$${current_savings}`
      }
      //check if the savings badge exist
      const savingsBadge = document.getElementById(`savings-badge--${productID}`)
      if (savingsBadge) {
        savingsBadge.innerHTML = locale.collection.product.discount_html.replace('{{savings}}', savingsText)
      } else {
        const savingsBadgeSpan = document.createElement('span')
        savingsBadgeSpan.classList.add('product-label')
        savingsBadgeSpan.classList.add('product-label--on-sale')
        savingsBadgeSpan.id = `savings-badge--${productID}`
        savingsBadgeSpan.innerHTML = locale.collection.product.discount_html.replace('{{savings}}', savingsText)

        badgeContainer.appendChild(savingsBadgeSpan)
      }
    } else {
      //check if the savings badge exist
      const savingsBadge = document.getElementById(`savings-badge--${productID}`)
      if (savingsBadge) {
        savingsBadge.remove()
      }
    }
    //add the deal badge
    const dealBadge = document.getElementById(`deals-badge--${productID}`)
    if (limited) {
      var dealBadgeText = locale.collection.product.limited
    } else if (discontinued) {
      var dealBadgeText = locale.collection.product.discontinued
    } else if (clearance) {
      var dealBadgeText = locale.collection.product.clearance
    } else if (isNew) {
      var dealBadgeText = locale.collection.product.new
    }


    if (dealBadgeText !== undefined) {
      if (dealBadge) {
        dealBadge.innerHTML = dealBadgeText
      } else {
        const dealBadgeSpan = document.createElement('span')
        if (discontinued) {
          dealBadgeSpan.classList.add('product-label')
          dealBadgeSpan.classList.add('product-label--custom2')
        } else {
          dealBadgeSpan.classList.add('product-label')
          dealBadgeSpan.classList.add('product-label--custom1')
        }
        dealBadgeSpan.id = `deals-badge--${productID}`
        dealBadgeSpan.innerHTML = dealBadgeText
        badgeContainer.appendChild(dealBadgeSpan)
      }
    } else {
      if (dealBadge) {
        dealBadge.remove()
      }
    }

  } catch (error) {
    console.error(error.message)
  }

}






//main-product.liquid variant change
document.addEventListener('variant:changed', function (event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  variant.metafields = variantMetafields[variant.id]

  let matchingInventory = 0

  const currentDate = convertToUTCDate(new Date().toISOString()).getTime();

  //variables
  //determin if the product is preorder
  var preOrder = false
  if (variant.metafields.custom.release_date) {
    const releaseDate = convertToUTCDate(variant.metafields.custom.release_date).getTime();
    if (currentDate < releaseDate) {
      preOrder = true;
    }
    var releaseDateText = variant.metafields.custom.release_date.split('T')[0]
  }

  //determin if the product is custom order
  var customOrder = false
  if (variant.metafields.custom.custom_order) {
    var customOrderText = variant.metafields.custom.custom_order
    customOrder = true
  }

  //determin if the product is discontinued
  var discontinued = false
  if (variant.metafields.custom.deals) {
    const deals = variant.metafields.custom.deals
    if (deals.includes("Discontinued")) {
      discontinued = true
    }
  }

  //determin if the product is limited
  var limited = false
  if (variant.metafields.custom.deals) {
    const deals = variant.metafields.custom.deals
    if (deals.includes("Limited Edition")) {
      limited = true
    }
  }

  //determin if the product is clearance
  var clearance = false
  if (variant.metafields.custom.deals) {
    const deals = variant.metafields.custom.deals
    if (deals.includes("Clearance")) {
      clearance = true
    }
  }

  //store incoming availablitly
  var incomingText = null
  var expectedDate = null
  var backorderMetafield = null
  try {
    const incomingAvailabiltyCont = document.getElementById(`inventoryIncomingContainer`)

    const variantInventory = variant.metafields.custom.inventory_quantities
    const variantIncomingInventory = variant.metafields.custom.incoming_inventory_quantities


    if (variantIncomingInventory && variantIncomingInventory[my_store]) {

      //const expectedInv = variantIncomingInventory[my_store].quantity
      //const expectedOn = new Date(variantIncomingInventory[my_store].expected_on + 'T16:00:00Z')
      //const formattedDate = expectedOn.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      //const today = new Date(new Date().toUTCString());
      ////calculate difference
      //const differenceInMilliseconds = expectedOn - today;
      //const differenceInSeconds = differenceInMilliseconds / 1000;
      //const differenceInMinutes = differenceInSeconds / 60;
      //const differenceInHours = differenceInMinutes / 60;
      //const differenceInDays = differenceInHours / 24;

      const now = new Date()
      const nowYear = now.getFullYear()
      const nowMonth = String(now.getMonth() + 1).padStart(2, '0')
      const nowDay = String(now.getDate()).padStart(2, '0')
      const todayString = `${nowYear}-${nowMonth}-${nowDay}`

      const today = new Date(todayString)
      const expected = new Date(variantIncomingInventory[my_store].expected_on)
      const differenceInDays = calculateDaysDifference(today, expected)

      if (differenceInDays === 0) {
        incomingText = locale.collection.product.incoming_today
      } else if (differenceInDays === 1) {
        incomingText = locale.collection.product.incoming_tomorrow
      } else if (differenceInDays > 1) {
        const expectedOn = new Date(variantIncomingInventory[my_store].expected_on + 'T16:00:00Z')
        const formattedDate = expectedOn.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        if (formattedDate || backorderDefault) {
          expectedDate = formattedDate
          incomingText = locale.collection.product.incoming_date.replace('{{date}}', formattedDate ? formattedDate : backorderDefault)
        }
      } else if (differenceInDays < 0 && differenceInDays > -45) {
        incomingText = locale.collection.product.incoming_on_the_way
      }

      //if (differenceInDays < 2 && differenceInDays > 1) {
      //  incomingText = locale.collection.product.incoming_tomorrow
      //} else if (differenceInDays < 1 && differenceInDays > 0) {
      //  incomingText = locale.collection.product.incoming_today
      //} else if (differenceInDays > 2) {
      //  expectedDate = formattedDate
      //  incomingText = locale.collection.product.incoming_date.replace('{{date}}', formattedDate)
      //} else {
      //  incomingText = locale.collection.product.incoming_on_the_way
      //}


      const lowInvThreshold = settings.low_inventory_threshold || 5

      if (variantInventory) {
        matchingInventory = variantInventory.available[my_store] || 0
      } else {
        matchingInventory = 0
      }
      matchingInventory < 0 ? matchingInventory = 0 : matchingInventory = matchingInventory


      if (incomingAvailabiltyCont) {
        if (expectedInv > 0 && matchingInventory < lowInvThreshold) {
          incomingAvailabiltyCont.style.display = 'table-row'
        } else {
          incomingAvailabiltyCont.style.display = 'none'
        }

        if (matchingInventory < lowInvThreshold) {
          incomingAvailabiltyCont.innerHTML = `
            <span class="product-form__info-title text--strong" name="">${locale.product.form.back_in_stock}</span>
            <span style="font-size:inherit" class="product-item__inventory inventory inventory--high inventory--noSub">${incomingText}</span>
          `
        }
      }

    } else {
      if (incomingAvailabiltyCont) {
        incomingAvailabiltyCont.style.display = 'none'
        incomingAvailabiltyCont.innerHTML = ``
      }
    }

  } catch (error) {
    console.error('inventory is not incoming, skipping...', error)
  }

  //backorder timeframe
  try {
    const backorderContainer = document.getElementById('backorderContainer')
    backorderMetafield = variant.metafields.custom.backorder



    if (variant.metafields.custom.inventory_quantities) {
      matchingInventory = variant.metafields.custom.inventory_quantities.available[my_store] || 0
    } else {
      matchingInventory = 0
    }
    matchingInventory < 0 ? matchingInventory = 0 : matchingInventory = matchingInventory

    if (settings.show_pickup_from_other_stores) {
      var isShipFromOtherStore = false
      if (matchingInventory === 0 && my_store !== 'warehouse' && variant.inventory_quantity > 0) {
        isShipFromOtherStore = true
        matchingInventory = variant.inventory_quantity
      }
    }


    if (!backorderMetafield && backorderContainer) {
      backorderContainer.innerHTML = ''
    } else if (backorderMetafield && backorderContainer && matchingInventory === 0) {
      backorderContainer.innerHTML = `
        <span class="product-form__info-title text--strong">${locale.product.form.backorders}</span>
        <span style="font-size:inherit" class="product-item__inventory inventory inventory--high">${backorderMetafield}</span>
        <input hidden="" id="backorder" type="text" value="${backorderMetafield}" name="properties[Backorder]">
      `
    } else if (backorderMetafield && backorderContainer && matchingInventory > 0) {
      backorderContainer.innerHTML = ''
    }
    if (backorderMetafield && matchingInventory === 0) {
      if (expectedDate && incomingText) {
        incomingText = incomingText
      } else {
        incomingText = backorderMetafield
      }
    }
  } catch (error) {
    console.error(error)
  }

  //store availablitly
  try {
    const availabiltyCont = document.getElementById(`inventoryContainer`)

    const span = document.createElement('span')
    span.classList.add('product-item__inventory')
    span.classList.add('inventory')
    span.style.fontSize = 'inherit'

    if (variant.metafields.custom.inventory_quantities) {
      matchingInventory = variant.metafields.custom.inventory_quantities.available[my_store] || 0
    } else {
      matchingInventory = 0
    }
    matchingInventory < 0 ? matchingInventory = 0 : matchingInventory = matchingInventory

    if (settings.show_pickup_from_other_stores) {
      var isShipFromOtherStore = false
      if (matchingInventory === 0 && my_store !== 'warehouse' && variant.inventory_quantity > 0) {
        isShipFromOtherStore = true
        matchingInventory = variant.inventory_quantity
      }
    }

    if (variant.inventory_policy === 'continue' && matchingInventory === 0 || preOrder) {
      span.classList.add('inventory--high')
      if (preOrder) {
        span.innerHTML = `${locale.product.form.pre_order} (<span style="font-style:italic;font-size:95%">${locale.product.form.releases.replace('{{date}}', releaseDateText)}</span>)`
      } else if (customOrder) {
        span.innerHTML = `${locale.product.form.custom_order} (<span style="font-style:italic;font-size:95%">${incomingText ? incomingText : customOrderText}</span>)`
      } else {
        span.innerHTML = `${backorderMetafield ? locale.product.form.backorders : locale.product.form.oversell_stock}${incomingText ? ` (${incomingText})` : ''}`
      }
    } else {
      if (matchingInventory === 0) {
        span.classList.add('inventory--noSub')
        span.innerHTML = `${locale.product.form.sold_out}${incomingText ? ` (${incomingText})` : ''}`
      } else {
        span.classList.add('inventory--noSub')
        if (isShipFromOtherStore) {
          span.classList.add('inventory--high')
          span.innerHTML = `${(locale.product.form.in_stock_from_other_store).replace('{{ store_name }}', matchingStore.name)}`
        } else {
          if (settings.low_inventory_threshold >= matchingInventory) {
            span.classList.add('inventory--low')
          } else {
            span.classList.add('inventory--high')
          }
          span.innerHTML = `${(locale.product.form.in_stock_with_quantity_count_2).replace('{{count}}', matchingInventory > settings.max_display_inventory ? `${settings.max_display_inventory}+` : matchingInventory)}`
        }
      }
    }

    const storeChanger = document.createElement('a')
    storeChanger.setAttribute('data-action', 'toggle-popover')
    storeChanger.setAttribute('aria-controls', 'store-selector')
    storeChanger.setAttribute('aria-expanded', 'false')
    storeChanger.setAttribute('onclick', "window.scrollTo({ top: 0, behavior: 'smooth' })")
    storeChanger.classList.add('link')
    storeChanger.style.cursor = 'pointer'
    storeChanger.style.fontStyle = 'italic'
    storeChanger.style.fontSize = '85%'
    storeChanger.style.color = 'grey'
    storeChanger.innerHTML = locale.product.labels.change_store

    availabiltyCont.innerHTML = ''
    availabiltyCont.appendChild(span)
    availabiltyCont.appendChild(storeChanger)
  } catch (error) {
    console.error('inventory is not shown, skipping...')
  }

  //buy buttons
  try {
    const buyButton = document.getElementById('addToCart')
    if (variant.inventory_policy === 'continue' && matchingInventory === 0 || preOrder || variant.inventory_management === null) {
      buyButton.classList.remove('button--disabled')
      buyButton.classList.add('button--primary')
      buyButton.removeAttribute('disabled')
      if (preOrder) {
        buyButton.innerHTML = `${locale.product.form.pre_order}`
      } else if (customOrder) {
        buyButton.innerHTML = `${locale.product.form.custom_order}`
      } else if (variant.inventory_management === null) {
        buyButton.innerHTML = `${locale.product.form.add_to_cart}`
      } else {
        const backorderMetafield = variant.metafields.custom.backorder
        if (backorderMetafield) {
          buyButton.innerHTML = `${locale.product.form.backorder_now}`
        } else {
          buyButton.innerHTML = `${locale.product.form.coming_soon}`
        }
      }
    } else {
      if (matchingInventory === 0) {
        buyButton.classList.add('button--disabled')
        buyButton.disabled = 'disabled'
        buyButton.innerHTML = `${locale.product.form.sold_out}`
      } else {
        buyButton.classList.remove('button--disabled')
        buyButton.classList.add('button--primary')
        buyButton.removeAttribute('disabled')
        buyButton.innerHTML = `${locale.product.form.add_to_cart}`
      }
    }
  } catch (error) {
    console.error(error)
  }

  //product specs
  try {

    const table = document.getElementById('product-specs-tbody')
    table.innerHTML = ''

    //brand
    var tableRow = table.insertRow()
    tableRow.insertCell().innerHTML = locale.product.info.brand
    tableRow.insertCell().innerHTML = product.metafields.properties.brand

    //sku
    var tableRow = table.insertRow()
    tableRow.insertCell().innerHTML = locale.product.info.sku
    tableRow.insertCell().innerHTML = variant.sku

    //catalog #
    var tableRow = table.insertRow()
    tableRow.insertCell().innerHTML = locale.product.info.catalog
    tableRow.insertCell().innerHTML = variant.id

    //metafields
    for (const key of metafieldKeys) {//defined at start of custom.js
      if (variant.metafields.custom[key] !== undefined) {
        if (key === 'product_information') {
          const object = variant.metafields.custom[key]

          for (let x in object) {

            const tableRow = table.insertRow()
            tableRow.insertCell().innerHTML = x
            tableRow.insertCell().innerHTML = object[x]
          }
        } else if (key === 'product_weight') {
          const tableRow = table.insertRow()
          tableRow.insertCell().innerHTML = locale.product.info[key]
          tableRow.insertCell().innerHTML = `${variant.metafields.custom[key].value} ${variant.metafields.custom[key].unit}`
        } else {
          if (typeof (variant.metafields.custom[key]) === 'object') {
            var value = variant.metafields.custom[key].join(', ')
          } else {
            var value = variant.metafields.custom[key]
          }

          if (value !== undefined) {

            const tableRow = table.insertRow()
            tableRow.insertCell().innerHTML = locale.product.info[key]
            tableRow.insertCell().innerHTML = value

          }
        }
      }
    }

  } catch (error) {
    console.error(error)
  }


  //product discounts
  try {


    const discountMetafields = matchingInventory > 0 ? variant.metafields.custom.current_discounts : null

    var discountActive = false
    var discountUpcoming = false
    var discountNewPrice = false
    var discountTitle = null
    var discountEnd = null
    var discountStart = null
    if (discountMetafields && discountMetafields.length > 0) {
      try {
        let discountMetafield = discountMetafields[0]

        try {// try and see if any other discounts have a greater value
          for(const discount of discountMetafields){
          const lastDiscountPercentage = discountMetafield.discountType === 'DiscountPercentage' ? discountMetafield.discountAmount : (((variantPrice - discountMetafield.discountAmount) / variantPrice) - 1) * -1

            if(discount.discountType == 'DiscountAmount'){
              const priceForDiscount = variantPrice - discount.discountAmount
              const discountPercentage = ((priceForDiscount / variantPrice) - 1) * -1
              if(discountPercentage > lastDiscountPercentage){
                discountMetafield = discount
              }
            }
          }
        } catch (error) {
          console.error(error)
        }

        const now = new Date()
        discountStart = new Date(discountMetafield.discountStart)
        discountEnd = discountMetafield.discountEnd ? new Date(discountMetafield.discountEnd) : null
        discountTitle = discountMetafield.discountTitle
        const discountAmount = discountMetafield.discountAmount
        const discountType = discountMetafield.discountType
        const discountCurrency = discountMetafield.discountCurrency

        if (now >= discountStart && (now <= discountEnd || !discountEnd)) {
          discountActive = true
          if (discountType === 'DiscountAmount' || discountType === 'DiscountPercentage') {
            if (discountType === 'DiscountPercentage') {
              const multiplier = 1 - discountAmount
              discountNewPrice = settings.currency_code_enabled ? window.theme.moneyWithCurrencyFormat.replace('{{amount}}', ((variant.price / 100) * multiplier).toFixed(2)) : window.theme.moneyFormat.replace('{{amount}}', (variantPrice * multiplier).toFixed(2))
            } else if (discountType === 'DiscountAmount') {
              if (window.currencyCode === discountCurrency) {
                discountNewPrice = settings.currency_code_enabled ? window.theme.moneyWithCurrencyFormat.replace('{{amount}}', ((variant.price / 100) - discountAmount).toFixed(2)) : window.theme.moneyFormat.replace('{{amount}}', (variantPrice - discountAmount).toFixed(2))
              } else {
                discountNewPrice = 0
              }
            }
          }
        } else if (now <= discountStart) {
          discountUpcoming = true
        }
        console.log(now, discountStart, discountEnd, now >= discountStart && now <= discountEnd, discountType)

      } catch (error) {
        console.error(error)
      }
    }
    console.log(discountNewPrice, discountActive && discountNewPrice === 0, discountActive && discountNewPrice !== 0, `discountUpcoming: ${discountUpcoming}`)

    const priceDom = document.getElementById('price-list-item')
    const parent = priceDom.parentNode
    const salePriceDom = document.getElementById('sale-price-list-item')
    const promoTitleDom = document.getElementById('promo-item')
    const saleEndsDom = document.getElementById('promo-ends-item')

    if ((discountActive && discountNewPrice === 0) || (discountActive && discountNewPrice !== 0) || (discountUpcoming)) {

      const discountEndYear = discountEnd ? discountEnd.getFullYear() : null;
      const discountEndMonth = discountEnd ? String(discountEnd.getMonth() + 1).padStart(2, '0') : null;
      const discountEndDay = discountEnd ? String(discountEnd.getDate()).padStart(2, '0') : null;

      let discountEndHour = discountEnd ? discountEnd.getHours() : null;
      const discountEndMinute = discountEnd ? String(discountEnd.getMinutes()).padStart(2, '0') : null;
      const ampm = discountEndHour ? discountEndHour >= 12 ? 'PM' : 'AM' : null;
      discountEndHour = discountEndHour ? discountEndHour % 12 : null;
      discountEndHour = discountEndHour ? discountEndHour ? discountEndHour : 12 : null; // The hour '0' should be '12'

      const discountStartYear = discountStart.getFullYear();
      const discountStartMonth = String(discountStart.getMonth() + 1).padStart(2, '0');
      const discountStartDay = String(discountStart.getDate()).padStart(2, '0');

      let discountStartHour = discountStart.getHours();
      const discountStartMinute = String(discountStart.getMinutes()).padStart(2, '0');
      const ampmStart = discountStartHour >= 12 ? 'PM' : 'AM';
      discountStartHour = discountStartHour % 12;
      discountStartHour = discountStartHour ? discountStartHour : 12; // The hour '0' should be '12'

      const saleEndsInner = `
          <span class="product-form__info-title text--strong">${discountUpcoming ? locale.product.general.starts : locale.product.general.ends}:</span>
          <div class="price-list">
            <span class="sale-ends-date">${discountUpcoming ? `${discountStartYear}-${discountStartMonth}-${discountStartDay} ${discountStartHour}:${discountStartMinute} ${ampmStart}` : `${discountEndYear}-${discountEndMonth}-${discountEndDay} ${discountEndHour}:${discountEndMinute} ${ampm}`} CST</span>
          </div>
        `
      if (saleEndsDom && discountEnd) {
        saleEndsDom.innerHTML = saleEndsInner
      } else if (discountEnd) {
        const newSaleEndsDom = document.createElement('div')
        newSaleEndsDom.classList.add('product-form__info-item')
        newSaleEndsDom.id = 'promo-ends-item'
        newSaleEndsDom.innerHTML = saleEndsInner
        parent.insertBefore(newSaleEndsDom, priceDom.nextSibling);
      }

      const promoTitleInner = `
        <span class="product-form__info-title text--strong">${locale.product.general.promo}:</span>
        <div class="price-list">
          ${discountTitle}
        </div>
      `
      if (promoTitleDom) {
        promoTitleDom.innerHTML = promoTitleInner
      } else {
        const newPromoTitleDom = document.createElement('div')
        newPromoTitleDom.classList.add('product-form__info-item')
        newPromoTitleDom.id = 'promo-item'
        newPromoTitleDom.innerHTML = promoTitleInner
        parent.insertBefore(newPromoTitleDom, priceDom.nextSibling);
      }

      if (salePriceDom && discountUpcoming) {
        salePriceDom.remove()
      }
    } else {
      if (salePriceDom) {
        salePriceDom.remove()
      }
      if (promoTitleDom) {
        promoTitleDom.remove()
      }
      if (saleEndsDom) {
        saleEndsDom.remove()
      }
    }

    if (discountActive && discountNewPrice !== 0) {
      const salePriceInner = `
      <span class="product-form__info-title text--strong">${locale.product.general.sale_price}:</span>
      <div class="price-list">
        <span class="price price--highlight">
          <span class="visually-hidden">Sale price</span>${discountNewPrice}</span>
      </div>
    `
      if (salePriceDom) {
        salePriceDom.innerHTML = salePriceInner
      } else {
        const newSalePriceDom = document.createElement('div')
        newSalePriceDom.classList.add('product-form__info-item')
        newSalePriceDom.id = 'sale-price-list-item'
        newSalePriceDom.innerHTML = salePriceInner
        parent.insertBefore(newSalePriceDom, priceDom.nextSibling);
      }
    }

  } catch (error) {
    console.error(error)
  }

  //variant promo details
  try {
    const promoInfo = document.getElementById('promo-text')
    if (promoInfo) {
      const metafield = variant.metafields.properties.special_manufacturing_info
      if (metafield) {
        promoInfo.innerHTML = metafield
      } else {
        promoInfo.innerHTML = ''
      }
    }
  } catch (error) {
    console.error(error)
  }

});










//supporting functions

function incomingInventoryText(dateStr, inv) {
  if (inv > 10) {
    inv = '10+'
  }
  // Convert the input string to a Date object in UTC
  const inputDate = new Date(dateStr + 'T00:00:00Z');

  // Get today's date in UTC
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);

  // Calculate the difference in milliseconds
  const timeDifference = inputDate - today;


  // Calculate the difference in days
  const daysDifference = Math.round(timeDifference / (1000 * 3600 * 24));


  if (daysDifference === 0) {
    return locale.collection.product.incoming_today;
  } else if (daysDifference === 1) {
    return locale.collection.product.incoming_tomorrow;
  } else if (daysDifference > 1) {
    return locale.collection.product.incoming_date.replace('{{date}}', dateStr); // Date is in the future
  } else {
    return locale.collection.product.incoming_on_the_way; // Date is in the past
  }
}

function convertToUTCDate(dateStr) {
  const localDate = new Date(dateStr);
  const utcDate = new Date(localDate.getTime() + localDate.getTimezoneOffset() * 60000);
  return utcDate;
}

function clickButton(id) {
  document.getElementById(id).click()
}












// get the users closest store location

function haversine(lat1, lon1, lat2, lon2) {
  // Convert latitude and longitude from degrees to radians
  const toRadians = (angle) => angle * (Math.PI / 180);
  lat1 = toRadians(lat1);
  lon1 = toRadians(lon1);
  lat2 = toRadians(lat2);
  lon2 = toRadians(lon2);

  // Haversine formula
  const dlat = lat2 - lat1;
  const dlon = lon2 - lon1;
  const a = Math.sin(dlat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dlon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  // Radius of the Earth in kilometers (you can use 3956 for miles)
  const radius = 6371.0;

  // Calculate the distance
  const distance = radius * c;

  return distance;
}

function findNearestLocation(userLat, userLon) {
  // Example array of locations

  const locations = storeDetails.filter(store => store.latitude)

  // Calculate distances and find the nearest location
  const nearestLocation = locations.reduce((nearest, loc) => {
    const distance = haversine(userLat, userLon, loc.latitude, loc.longitude);
    if (distance < nearest.distance || nearest.distance === null) {
      return { location: loc, distance };
    }
    return nearest;
  }, { location: null, distance: null });

  return nearestLocation;
}

function getLocation() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const userLat = position.coords.latitude;
        const userLon = position.coords.longitude;

        nearestLocation = findNearestLocation(userLat, userLon);
        console.log("User Location:", { userLat, userLon });
        console.log("Nearest Location:", nearestLocation);

      },
      (error) => {
        console.error("Error getting user location:", error.message);
      }
    );
  } else {
    console.error("Geolocation is not supported by this browser.");
  }
}

//getLocation();

document.body.addEventListener('click', function (event) {
  // Check if the clicked element is a link
  const target = event.target.closest('a');
  if (target) {
    // Handle URL change
    console.log('URL changed:', target.href);
  }
});




// dates
function formatDate(inputFormat) {
  var today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');

  // Replace placeholders with actual date components
  const formattedDate = inputFormat
    .replace('yyyy', year)
    .replace('mm', month)
    .replace('dd', day);

  return formattedDate;
}

function getDate0Hour(dateInput) {
  const inputDate = dateInput ? new Date(dateInput) : new Date();

  // Set time to start of the day (12:00 AM)
  inputDate.setHours(0, 0, 0, 0);

  const year = inputDate.getFullYear();
  const month = String(inputDate.getMonth() + 1).padStart(2, '0');
  const day = String(inputDate.getDate()).padStart(2, '0');

  // Return date without formatting
  return new Date(year, inputDate.getMonth(), day);
}

function calculateDaysDifference(startDate, endDate) {
  // Convert the input dates to UTC to avoid issues with daylight saving time
  const startUtc = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  const endUtc = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

  // Calculate the difference in milliseconds
  const differenceInMs = endUtc - startUtc;

  // Convert the difference to days and represent it in decimal format
  const differenceInDays = differenceInMs / (1000 * 60 * 60 * 24);

  return differenceInDays;
}






//Instock checkboxes
try {

  if (document.getElementsByClassName('collection__dynamic-part')[0]) {
    function handleCheckboxRemoval(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
          const productList = document.querySelector('.product-list')
          if (productList) {
            const productCards = productList.querySelectorAll('.product-item')
            if (productCards.length === 0) {
              const pagination = document.querySelector('.pagination')
              if (pagination) {
                const backButton = pagination.querySelector('.pagination__prev')
                const nextButton = pagination.querySelector('.pagination__next')
                if (nextButton) {
                  nextButton.click()
                } else {
                  backButton.click()
                }
              }
            }
          }
          runCheckboxes()
        }
      }
    }

    // Create a MutationObserver to observe changes in the DOM
    const checkboxObserver = new MutationObserver(handleCheckboxRemoval);

    // Configure the observer to watch for changes in the container
    const observerConfig = { childList: true };

    // Start observing changes on elements with name "filterCheckbox"

    checkboxObserver.observe(document.getElementsByClassName('collection__dynamic-part')[0], observerConfig);
  }

  runCheckboxes(localStorage.getItem('inStockChoice'))

  function runCheckboxes(setValue) {
    const checkboxes = Array.from(document.getElementsByName('filterCheckbox'))

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function (event) {
        // Access the checked state of the checkbox
        const isChecked = event.target.checked;

        const targetId = document.getElementById(event.target.getAttribute('targetId'))
        const targetIds = event.target.getAttribute('targetIds')

        if (targetIds) {
          if (targetIds === 'filter.p.product_type-Approved For All') {
            const container = document.getElementById('filter-p-product_type')
            const children = container.querySelectorAll('input')
            var ids = []
            children.forEach(element => {
              ids.push(element.id)
            });
          } else {
            var ids = targetIds.split(",")
          }
          for (const id of ids) {
            const targetId = document.getElementById(id)
            if (targetId) {
              targetId.click()
            }
          }
        } else {
          targetId.click()
        }
        localStorage.setItem(event.target.id, isChecked)


      });
      const targetId = document.getElementById(checkbox.getAttribute('targetId'))
      const targetIds = checkbox.getAttribute('targetIds')
      if (targetId) {
        checkbox.checked = targetId.checked


        if (isElementVisible(checkbox) && setValue === 'true') {
          if (!targetId.checked) {
            targetId.click()
          }
        }
      } else if (targetIds) {
        if (targetIds === 'filter.p.product_type-Approved For All') {
          const container = document.getElementById('filter-p-product_type')
          const children = container.querySelectorAll('input')
          var ids = []
          children.forEach(element => {
            ids.push(element.id)
          });
        } else {
          var ids = targetIds.split(",")
        }
        var checkedElements = 0
        var totalElements = 0
        for (const id of ids) {
          const targetId = document.getElementById(id)
          if (targetId) {
            totalElements++
          }
          if (targetId && targetId.checked) {
            checkedElements++
          }
        }
        if (checkedElements === totalElements && totalElements > 0) {
          if (!checkbox.getAttribute('checked')) {
            checkbox.checked = 'checked'
          }
        }
        if (totalElements === 0) {
          checkbox.disabled = 'disabled'
          checkbox.parentNode.parentNode.style.display = 'none'
        }
      } else {
        checkbox.disabled = 'disabled'
        checkbox.parentNode.parentNode.style.display = 'none'
      }

    });
  }

} catch (error) {
  console.error(error)
}

function isElementVisible(element) {
  let currentElement = element;

  // Traverse up the DOM hierarchy
  while (currentElement) {
    const style = window.getComputedStyle(currentElement);

    // Check the visibility of the current element
    const display = style.getPropertyValue('display');
    const visibility = style.getPropertyValue('visibility');

    if (display === 'none' || visibility === 'hidden') {
      return false; // Element or one of its ancestors is hidden
    }

    currentElement = currentElement.parentElement;
  }

  return true; // Element is visible
}



//product page load
if (location.href.includes("/products/")) {
  try {
    const allVariantMetafields = window.variantMetafields
    const product = window.product
    product.metafields = window.productMetafields

    const variants = product.variants

    for (const variant of variants) {
      variant.metafields = allVariantMetafields[variant.id]
    }

    const params = {};
    if (location.href.includes('?')) {
      const urlParams = location.href.split('?')[1].split('&');
      for (const param of urlParams) {
        const key = param.split('=')[0];
        const value = param.split('=')[1];
        params[key] = value; // Use "let" instead of "const"
      }
    }

    if (params.variant) {
      var firstVariant = variants.find(variant => variant.id === parseInt(params.variant))
    } else {
      var firstVariant = variants[0]
    }

    //product specs
    try {

      const table = document.getElementById('product-specs-tbody')
      table.innerHTML = ''

      //brand
      var tableRow = table.insertRow()
      tableRow.insertCell().innerHTML = locale.product.info.brand
      tableRow.insertCell().innerHTML = product.metafields.properties.brand

      //sku
      var tableRow = table.insertRow()
      tableRow.insertCell().innerHTML = locale.product.info.sku
      tableRow.insertCell().innerHTML = firstVariant.sku

      //catalog #
      var tableRow = table.insertRow()
      tableRow.insertCell().innerHTML = locale.product.info.catalog
      tableRow.insertCell().innerHTML = firstVariant.id

      //metafields
      for (const key of metafieldKeys) {//defined at start of custom.js
        if (firstVariant.metafields.custom[key] !== undefined) {
          if (key === 'product_information') {
            const object = firstVariant.metafields.custom[key]

            for (let x in object) {

              const tableRow = table.insertRow()
              tableRow.insertCell().innerHTML = x
              tableRow.insertCell().innerHTML = object[x]
            }
          } else if (key === 'product_weight') {
            const tableRow = table.insertRow()
            tableRow.insertCell().innerHTML = locale.product.info[key]
            tableRow.insertCell().innerHTML = `${firstVariant.metafields.custom[key].value} ${firstVariant.metafields.custom[key].unit}`
          } else {
            if(key === 'length' || key === 'width' || key === 'height'){
              var value = `${firstVariant.metafields.custom[key].value} ${firstVariant.metafields.custom[key].unit}`
            } else if (typeof (firstVariant.metafields.custom[key]) === 'object') {
              var value = firstVariant.metafields.custom[key].join(', ')
            } else {
              var value = firstVariant.metafields.custom[key]
            }

            if (value !== undefined) {

              const tableRow = table.insertRow()
              tableRow.insertCell().innerHTML = locale.product.info[key]
              tableRow.insertCell().innerHTML = value

            }
          }
        }
      }

    } catch (error) {
      console.error(error)
    }

  } catch (error) {
    console.error(error)
  }
}








//saved carts styling
processTableChange()
function processTableChange() {
  try {
    const currentURL = location.href
    if (currentURL.includes('/a/saved-carts')) {
      const table = document.querySelector('table')
      table.classList.add('table')
    }
  } catch (error) {
    setTimeout(() => {
      processTableChange()
    }, 300);
  }
}




//quick links (brands) searching 
function searchBrands(value) {
  const searchValue = value.toLowerCase()

  const links = Array.from(document.querySelectorAll('.quick-links__link'))

  for (const link of links) {
    if (searchValue === '') {
      link.style.display = 'flex'
    } else {
      const linkValue = link.id.toLowerCase()
      if (linkValue.includes(searchValue)) {
        link.style.display = 'flex'
      } else {
        link.style.display = 'none'
      }
    }
  }

}


// Create a new MutationObserver
const observer = new MutationObserver((mutationsList, observer) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const childElement = node.querySelector('.g-recaptcha-bubble-arrow');
          if (childElement) {
            console.log('Added:', node);
            //node.style.position = 'fixed';
            //node.style.left = '0px';
          }
        }
      });
    }
  }
});

// Start observing the DOM for changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});



console.log(locale, settings, storeDetails, icons, theme, routes, languages)


//education

async function changeCampus(value, productId, variantJSON) {
  console.log(variantJSON.replaceAll('|||', '"'))
  const variants = JSON.parse(variantJSON.replaceAll('|||', '"'))
  const matchingVariants = variants.variants.filter(variant => variant.option1 === value)
  const datesSelector = document.getElementById(`Dates--${productId}`)
  console.log(datesSelector)
  datesSelector.innerHTML = ''
  for (const variant of matchingVariants) {
    const option = document.createElement('option')
    option.value = variant.option2
    option.innerHTML = variant.option2
    datesSelector.appendChild(option)
  }
}

const educationForms = Array.from(document.getElementsByName('educationForm'))

for (const form of educationForms) {
  form.addEventListener('submit', (event) => {
    if (form instanceof HTMLFormElement) {
      event.preventDefault();
      // Rest of your code...
      const productId = form.id.split('--')[1]

      const errorCont = document.getElementById(`error-container--${productId}`)

      const variantJSON = form.getAttribute('variantJSON')
      const variantJSON2 = form.getAttribute('variantJSON2')

      const variants = JSON.parse(variantJSON.replaceAll('|||', '"'))
      const variants2 = JSON.parse(variantJSON2.replaceAll('|||', '"'))
      console.log(variants, variants2)

      var cartLink = `/cart/${variants2.variants[0].option1 === 'Default Title' ? `${variants2.variants[0].id}:1,` : ``}`
      console.log(cartLink)

      const selects = Array.from(form.querySelectorAll('select'))
      for (const select of selects) {
        console.log(select)
        if (select.id.includes('Date')) {
          var campusValue = select.value
        } else if (select.id.includes('campus')) {
          var datesValue = select.value
        } else if (select.id.includes('Textbook')) {
          var textbook = select.value
        }
      }
      console.log(textbook, campusValue, datesValue, variants.variants)

      if (campusValue && datesValue && textbook) {
        const matchingVariant = variants.variants.find(item => Object.values(item).includes(campusValue) && Object.values(item).includes(datesValue))
        const matchingVariant2 = variants2.variants.find(item => Object.values(item).includes(textbook))
        console.log(matchingVariant)
        if (matchingVariant && matchingVariant2) {
          cartLink += `${matchingVariant.id}:1,${matchingVariant2.id}:1`
          console.log(cartLink)
          location.href = cartLink
        } else {
          errorCont.innerHTML = `${locale.header.general.register_error} <a href="mailto:education@creatabeauty.com" class="link">education@creatabeauty.com</a>`
          errorCont.style.opacity = '1'
          setTimeout(() => {
            errorCont.style.opacity = '0'
          }, 10000);
        }
      } else if (campusValue && datesValue) {
        const matchingVariant = variants.variants.find(item => Object.values(item).includes(campusValue) && Object.values(item).includes(datesValue))
        console.log(matchingVariant)
        if (matchingVariant) {
          cartLink += `${matchingVariant.id}:1`
          console.log(cartLink)
          location.href = cartLink
        } else {
          errorCont.innerHTML = `${locale.header.general.register_error} <a href="mailto:education@creatabeauty.com" class="link">education@creatabeauty.com</a>`
          errorCont.style.opacity = '1'
          setTimeout(() => {
            errorCont.style.opacity = '0'
          }, 10000);
        }
      } else {
        errorCont.innerHTML = `${locale.header.general.register_error} <a href="mailto:education@creatabeauty.com" class="link">education@creatabeauty.com</a>`
        errorCont.style.opacity = '1'
        setTimeout(() => {
          errorCont.style.opacity = '0'
        }, 10000);
      }
    }
  })
}

async function changeEduPrice(productId, variantJSON, variantJSON2) {
  const variants = JSON.parse(variantJSON.replaceAll('|||', '"'))
  const variants2 = JSON.parse(variantJSON2.replaceAll('|||', '"'))
  console.log(productId, variants, variants2)
  const form = document.getElementById(`form--${productId}`)
  const selects = form.querySelectorAll('select')
  for (const select of selects) {
    console.log(select)
    if (select.id.includes('Date')) {
      var campusValue = select.value
    } else if (select.id.includes('campus')) {
      var datesValue = select.value
    } else if (select.id.includes('Textbook')) {
      var textbook = select.value
    }
  }
  console.log(campusValue, datesValue, textbook)
  if (campusValue && datesValue && textbook) {
    const matchingVariant = variants.variants.find(item => Object.values(item).includes(campusValue) && Object.values(item).includes(datesValue))
    const matchingVariant2 = variants2.variants.find(item => Object.values(item).includes(textbook))
    console.log(matchingVariant, matchingVariant2)
    if (matchingVariant && matchingVariant2) {
      const newPrice = parseFloat(matchingVariant.price) + parseFloat(matchingVariant2.price)
      if (settings.currency_code_enabled) {
        var NewPriceFormatted = theme.moneyWithCurrencyFormat.replace('{{amount}}', formatCurrency(newPrice))
      } else {
        var NewPriceFormatted = theme.moneyFormat.replace('{{amount}}', formatCurrency(newPrice))
      }
      console.log(NewPriceFormatted)
      const priceField = document.getElementById(`class-price--${productId}`)
      priceField.innerHTML = NewPriceFormatted
    }
  }
}

function formatCurrency(cents) {
  // Convert cents to dollars
  const dollars = cents / 100;

  // Format dollars with commas for thousands separation and two decimal places for cents
  const formattedDollars = dollars.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return formattedDollars;
}





function changeHoldText(value) {
  try {
    const holdElements = Array.from(document.querySelectorAll('.cart-heading--pre-order'))
    if (holdElements.length > 0) {
      if (value === 'Split') {
        for (const element of holdElements) {
          element.innerHTML = element.innerHTML.replace(' Order will be held', ' Order will be split')
        }
      } else if (value === 'Hold') {
        for (const element of holdElements) {
          element.innerHTML = element.innerHTML.replace(' Order will be split', ' Order will be held')
        }
      }
    }
  } catch (error) {
    console.error(error)
  }
}